<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'审核管理'},{name:'申请政策申报审核',goback:true},{name:'政策申报详细信息'}]" :title="'政策申报详细信息'"/>
            <!-- 主体内容 -->
            <!-- 用户明细 -->
            <div class="box">
               <el-card class="basic box_card" header="基本信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">政策申报标题：</div>
                        <div class="content">{{titleInfo.policyName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">适用行业：</div>
                        <div class="content">
						{{titleInfo.industry}}
						</div>
                    </div>
                  </el-col>
                 
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">适用地区：</div>
                        <div class="content">{{titleInfo.provinceValue+titleInfo.cityValue+titleInfo.areaValue}}</div>
                    </div>
                    </el-col>
                 
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">来源：</div>
                        <div class="content">{{titleInfo.source}}</div>
                    </div>
                  </el-col>
                 </el-row>
                 <el-row>
                  <el-col :span="24">
                    <div class="child">
                        <div class="name">政策详情：</div>
                        <div class="content super_p" v-html="titleInfo.policyDetails"></div>
                    </div>
                  </el-col>
                  </el-row>
                 <el-row>
                  <el-col :span="24">
                    <div class="childMulti">
                        <div class="name">申报流程：</div>
                        <ul>
                            <li v-for="(item,i) in titleInfo.declareProcess" :key="i">
                                {{(i+1)+'.'+item.content}}
                            </li>
                        </ul>
                    </div>
                  </el-col>
                  </el-row>
                 
                 <el-row>
                  <el-col :span="24">
                    <div class="attachment" v-if="titleInfo.fileList&&titleInfo.fileList.length>0">
                        <div class="name">附件：</div>
                        <ul class="content">
                            <li v-for="(item,i) in titleInfo.fileList" :key="i">
                                <span>{{item.fileName}}</span><i class="el-icon-download" @click="downLoad(item)"></i>
                            </li>
                        </ul>
                    </div>
                  </el-col>
                </el-row>
              </el-card>
              
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import {onDownload} from "@/utils/common";
export default {
    components:{
        breadcrumb
    },
    data(){
        return{
            tab:'1',//选项卡
            id:'',//详情id
            titleInfo:{
                policyName:"",
                industry:'',
                areaValue:"",
                source:"",
                policyDetails:"",
                declareProcess:[],
                fileList:[]
            }
		
        }
    },
    methods:{
        //下载附件
        downLoad:function({fileName,filePath}){
           const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
        },
        //获取数据
        async getData(){
         const {code,data,msg} = await this.$axiosc.get('backstage/policy/declare/details/'+this.id)
          if (code == 200) {            
              this.titleInfo = data
              let value = []
              this.titleInfo.industry.map(val=>{
                  value.push(val.value)
              })
              this.titleInfo.industry = value.join('/')
          } else {
              this.$alert(msg)
          }
        }
    },
    created(){
        this.tab=this.$route.params.type
        this.id=this.$route.query.id;
    },
    mounted(){
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
.warp{
  height:100%;
  overflow: hidden;
}
.box{
  height: calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
}
.basic{
  color:$font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col{
    margin: 10px 0;
  }
  .child{
    color:#595959;
  }
}
.main{
  background: transparent !important;
  padding:0 !important;
}
</style>